// components/message/Error.js
import React, { useEffect, useState } from "react";

const Error = ({ message, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 500); // Allow transition to complete before calling onClose
    }, 2500);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`fixed top-4 right-4 flex items-center align-center bg-agRedBg px-4 py-3 rounded-lg z-50 shadow-md transition-opacity duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      role="alert"
    >
      <div>
        <span className="material-icons-round mr-4 text-agRed">error</span>
      </div>
      <div className="text-agRed text-xs md:text-sm font-nunito max-w-56 mb-2">
        {message}
      </div>
      <div>
        <span
          onClick={() => {
            setIsVisible(false);
            setTimeout(onClose, 500); // Allow transition to complete before calling onClose
          }}
          className="material-icons-round text-agBlack cursor-pointer ml-4"
        >
          close
        </span>
      </div>
    </div>
  );
};

export default Error;
